"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _componentCommon = require("./component-common");

var _errorMessages = _interopRequireDefault(require("./error-messages"));

var _help = _interopRequireDefault(require("./help"));

var _row = _interopRequireDefault(require("./row"));

var _select = _interopRequireDefault(require("./controls/select"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Select =
/*#__PURE__*/
function (_Component) {
  _inherits(Select, _Component);

  function Select() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Select);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Select)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (event) {
      var target = event.currentTarget;
      var _this$props = _this.props,
          multiple = _this$props.multiple,
          onSetValue = _this$props.onSetValue,
          onChange = _this$props.onChange,
          name = _this$props.name;
      var value;

      if (multiple) {
        value = Array.from(target.options).filter(function (option) {
          return option.selected;
        }).map(function (option) {
          return option.value;
        });
      } else {
        value = target.value;
      }

      onSetValue(value);
      onChange(name, value);
    });

    _defineProperty(_assertThisInitialized(_this), "initElementRef", function (control) {
      _this.element = control ? control.element : null;
    });

    return _this;
  }

  _createClass(Select, [{
    key: "render",
    value: function render() {
      var inputProps = Object.assign({}, this.props);
      Object.keys(_componentCommon.componentPropTypes).forEach(function (key) {
        delete inputProps[key];
      });

      var control = _react.default.createElement(_select.default, _extends({}, inputProps, {
        onChange: this.handleChange,
        ref: this.initElementRef
      }));

      var _this$props2 = this.props,
          layout = _this$props2.layout,
          id = _this$props2.id,
          help = _this$props2.help,
          showErrors = _this$props2.showErrors,
          errorMessages = _this$props2.errorMessages;

      if (layout === 'elementOnly') {
        return control;
      }

      return _react.default.createElement(_row.default, _extends({}, this.props, {
        htmlFor: id
      }), control, help ? _react.default.createElement(_help.default, {
        help: help
      }) : null, showErrors ? _react.default.createElement(_errorMessages.default, {
        messages: errorMessages
      }) : null);
    }
  }]);

  return Select;
}(_react.Component);

Select.propTypes = _objectSpread({}, _select.default.propTypes, _componentCommon.componentPropTypes, {
  multiple: _propTypes.default.bool,
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    value: _propTypes.default.string,
    label: _propTypes.default.string,
    group: _propTypes.default.string
  }))
});
Select.defaultProps = _objectSpread({}, _componentCommon.componentDefaultProps, {
  options: []
});
var _default = Select;
exports.default = _default;